/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
} from './';

/**
 * 
 * @export
 * @interface TransactionDetails
 */
export interface TransactionDetails {
    /**
     * 
     * @type {string}
     * @memberof TransactionDetails
     */
    transactionDate: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetails
     */
    transactionType: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetails
     */
    method: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetails
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetails
     */
    userBank: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetails
     */
    change: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetails
     */
    balance: string;
    /**
     * 
     * @type {object}
     * @memberof TransactionDetails
     */
    metadata: object;
}

/**
 * Check if a given object implements the TransactionDetails interface.
 */
export function instanceOfTransactionDetails(value: object): value is TransactionDetails {
    let isInstance = true;
    isInstance = isInstance && "transactionDate" in value && value["transactionDate"] !== undefined;
    isInstance = isInstance && "transactionType" in value && value["transactionType"] !== undefined;
    isInstance = isInstance && "method" in value && value["method"] !== undefined;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "userBank" in value && value["userBank"] !== undefined;
    isInstance = isInstance && "change" in value && value["change"] !== undefined;
    isInstance = isInstance && "balance" in value && value["balance"] !== undefined;
    isInstance = isInstance && "metadata" in value && value["metadata"] !== undefined;

    return isInstance;
}

export function TransactionDetailsFromJSON(json: any): TransactionDetails {
    return TransactionDetailsFromJSONTyped(json, false);
}

export function TransactionDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        
        'transactionDate': json['transaction_date'],
        'transactionType': json['transaction_type'],
        'method': json['method'],
        'signature': json['signature'],
        'userBank': json['user_bank'],
        'change': json['change'],
        'balance': json['balance'],
        'metadata': json['metadata'],
    };
}

export function TransactionDetailsToJSON(value?: TransactionDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transaction_date': value.transactionDate,
        'transaction_type': value.transactionType,
        'method': value.method,
        'signature': value.signature,
        'user_bank': value.userBank,
        'change': value.change,
        'balance': value.balance,
        'metadata': value.metadata,
    };
}

